import type { GuestCatalogType } from "@/hooks/useGuestOpacTenantSlug";
import { cn } from "@/lib/utils";

const TYPE_OPTIONS: { value: GuestCatalogType; label: string }[] = [
  { value: "all", label: "All types" },
  { value: "physical", label: "Books" },
  { value: "journal", label: "Journals" },
  { value: "digital", label: "Digital" },
];

interface GuestCatalogTypeChipsProps {
  value: GuestCatalogType;
  disabled?: boolean;
  onChange: (value: GuestCatalogType) => void;
}

export function GuestCatalogTypeChips({ value, disabled, onChange }: GuestCatalogTypeChipsProps) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Resource type">
      {TYPE_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-full px-3 py-1.5 text-xs font-medium transition-colors duration-200",
            value === option.value
              ? "bg-primary text-primary-foreground shadow-sm"
              : "bg-white text-gray-600 ring-1 ring-gray-200 hover:bg-gray-50"
          )}
          aria-pressed={value === option.value}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
